import React from "react";
import styled from "styled-components";

import GroupingTable from "../GroupingTable";
import {boxShadowColour} from "../../../../style/styleConsts";

const shadowDepth = 50;

const Container = styled.div`    
    padding: 6px 10px 10px;
    overflow-y: hidden;
    flex-grow: 1;
    box-shadow: inset 0 -${shadowDepth}px ${shadowDepth}px -${shadowDepth}px ${boxShadowColour};
`;

const GroupingRows = ({
                          grouping = [],
                          currency,
                          selectedKpi,
                          limit,
                          showRank,
                          rowLinkGenerator = null
                      }) => {
    const rows = grouping.slice(0, limit);
    return <Container>
        <GroupingTable grouping={rows}
                       currency={currency}
                       showRank={showRank}
                       selectedKpi={selectedKpi}
                       rowLinkGenerator={rowLinkGenerator}/>
    </Container>;
};

export default GroupingRows;